// extracted by mini-css-extract-plugin
export var googleWrapper = "g-sign-in-module--googleWrapper--73659";
export var error = "g-sign-in-module--error--89bd9";